import * as React from "react";
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import MarketingPage from "./pages/MarketingPage";
import AdminDashboard from "./pages/AdminDashboard";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import CommunityDisplay from "./pages/CommunityDisplay";
import AdminSettings from "./pages/AdminSettings";
import PricingPage from "./pages/PricingPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import RefundPage from "./pages/RefundPage";
import { AuthProvider } from "./AuthContext";

import AppAppBar from "./components/AppAppBar";
import CssBaseline from "@mui/material/CssBaseline";
import AppTheme from "./AppTheme";
import "./i18n";

function App(props) {
  return (
    <AuthProvider>
      <Router>
        <AppWrapper {...props} />
      </Router>
    </AuthProvider>
  );
}

function AppWrapper(props) {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    // Met à jour la direction du document en fonction de la langue
    document.documentElement.dir = i18n.dir();
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      
      {/* Afficher AppAppBar sauf sur endpoints d'affichage TV */}
      {!(location.pathname.toLowerCase().startsWith("/display/") ||
        location.pathname.toLowerCase().startsWith("/displaylayout/")) && <AppAppBar />}
      
      <Routes>
        <Route path="/" element={<MarketingPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/refund" element={<RefundPage />} />
        <Route path="/SignInPage" element={<SignInPage />} />
        <Route path="/SignUpPage" element={<SignUpPage />} />
        <Route path="/VerifyEmail" element={<VerifyEmailPage />} />
        <Route path="/ResetPassword" element={<ResetPasswordPage />} />
        <Route path="/AdminDashboard" element={<AdminDashboard />} />
        <Route path="/display/:communityName" element={<CommunityDisplay />} />
        <Route
          path="/displayLayout/:communityName"
          element={<CommunityDisplay enableLayoutRenderer />}
        />
        <Route path="/adminSettings" element={<AdminSettings />} />
      </Routes>
    </AppTheme>
  );
}

export default App;
